import React, { Component } from 'react';

import _ from "lodash";
import CryptoJS from "crypto-js";
import moment from "moment";
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import { Dropdown, Form, Input, Popup } from 'semantic-ui-react'
import { translate } from "../../addons/Translate";

import { isoLangs } from "../../addons/languages";

const jobs = [
	{ key: 1, text: translate("xxltable.step3.jobs.1"), value: translate("xxltable.step3.jobs.1") },
  	{ key: 2, text: translate("xxltable.step3.jobs.2"), value: translate("xxltable.step3.jobs.2") }
];

const job_hours = [
	{ key: 1, text: translate("xxltable.step3.job_hours.1"), value: 1 },
  	{ key: 2, text: translate("xxltable.step3.job_hours.2"), value: 2 },
  	{ key: 3, text: translate("xxltable.step3.job_hours.3"), value: 3 },
  	{ key: 4, text: translate("xxltable.step3.job_hours.4"), value: 4 },
];

const qualifications = [
	{ key: 1, text: translate("xxltable.step3.qualifications.1"), value: 1 },
	{ key: 2, text: translate("xxltable.step3.qualifications.2"), value: 2 },
	{ key: 3, text: translate("xxltable.step3.qualifications.3"), value: 3 },
	{ key: 4, text: translate("xxltable.step3.qualifications.4"), value: 4 },
	{ key: 5, text: translate("xxltable.step3.qualifications.5"), value: 5 },
	{ key: 6, text: translate("xxltable.step3.qualifications.6"), value: 6 },
	{ key: 7, text: translate("xxltable.step3.qualifications.7"), value: 7 }
];

const eu_work_permit_options = [
  { key: 1, text: translate("xxltable.step3.eu_work_permit.1"), value: 1 },
  { key: 2, text: translate("xxltable.step3.eu_work_permit.2"), value: 2 }
];

const work_year_experience_options = [
  { key: 1, text: translate("xxltable.step3.work_year_experience.1"), value: 1 },
  { key: 2, text: translate("xxltable.step3.work_year_experience.2"), value: 2 },
  { key: 3, text: translate("xxltable.step3.work_year_experience.3"), value: 3 },
  { key: 4, text: translate("xxltable.step3.work_year_experience.4"), value: 4 },
  { key: 5, text: translate("xxltable.step3.work_year_experience.5"), value: 5 }
];

const renderLabel = label => ({
  color: 'blue',
  content: label.text
});

class ApplicationForm extends Component {
	form_field_key = Date.now()+"";

	state = {
		data: {
			job: !!this.props.data.job ? this.props.data.job : "",
			job_hours: !!this.props.data.job_hours ? this.props.data.job_hours : "",
			qualifications: !!this.props.data.qualifications ? this.props.data.qualifications : "",
			expected_salary: !!this.props.data.expected_salary ? this.props.data.expected_salary : "",
			languages_main: !!this.props.data.languages_main ? this.props.data.languages_main : [],
			languages_rest: !!this.props.data.languages_rest ? this.props.data.languages_rest : [],
			eu_work_permit: !!this.props.data.eu_work_permit ? this.props.data.eu_work_permit : 2,
			work_year_experience: !!this.props.data.work_year_experience ? this.props.data.work_year_experience : 1,
			available_day: !!this.props.data.available_day_u ? moment(this.props.data.available_day_u).format('DD/MM/YYYY') : "",
			available_day_u: !!this.props.data.available_day_u ? this.props.data.available_day_u : "",
			comment: !!this.props.data.comment ? this.props.data.comment : ""
		},
		loading: false,
		// error_server: false,
		// errors_response: {},
		errors: {},
		isOpen: false,
		job_hours_id: 0
	}

	constructor(props) {
		super(props);
		
		this.handleYearMonthChange = this.handleYearMonthChange.bind(this);

		if(props.data.jobId !== 0 && this.state.data.job === "" && props.data.job_hours === "") {
			this.state.data.job = props.data.jobDetails.title;
			this.state.data.job_hours = props.data.jobDetails.time_type;
		}

		this.state.job_hours_id = this.state.data.job_hours;
	}

	componentWillReceiveProps(props) {
		this.setState({
			data: {
				job: !!props.data.job ? props.data.job : "",
				job_hours: !!props.data.job_hours ? props.data.job_hours : "",
				qualifications: !!props.data.qualifications ? props.data.qualifications : "",
				expected_salary: !!props.data.expected_salary ? props.data.expected_salary : "",
				languages_main: !!props.data.languages_main ? props.data.languages_main : [],
				languages_rest: !!props.data.languages_rest ? props.data.languages_rest : [],
				eu_work_permit: !!props.data.eu_work_permit ? props.data.eu_work_permit : 2,
				work_year_experience: !!props.data.work_year_experience ? props.data.work_year_experience : 1,
				available_day: !!props.data.available_day_u ? moment(props.data.available_day_u).format('DD/MM/YYYY') : "",
				available_day_u: !!props.data.available_day_u ? props.data.available_day_u : "",
				comment: !!props.data.comment ? props.data.comment : ""
			}
		})
	}

	handleYearMonthChange(month) {
		this.setState({ month });
	}

	onChangeCheckErrors(name){
		if(this.state.errors[name] !== undefined) {
			this.setState({
				errors: _.omit(this.state.errors, name)
			});
		}
	}

	onChange = e => {
		let name = e.target.name;
		if(name.indexOf('crypto_') !== -1) {
			name = name.replace('crypto_', '');
			name = CryptoJS.AES.decrypt(name, this.form_field_key).toString(CryptoJS.enc.Utf8);
		}

		const data = {...this.state.data, [name]: e.target.value};
		this.props.onUpdate(data);

		this.onChangeCheckErrors(name);
	}

	onChangeSUI(e, {name, value}) {
		if(name === "job_hours") {
			this.setState({
				job_hours_id: value
			})
		}

		const data = {...this.state.data, [name]: value};
		this.props.onUpdate(data);
	}

	onChangeCountry(e, {value}) {
		const data = {...this.state.data, country: value};
		this.props.onUpdate(data);

		this.onChangeCheckErrors("country");
	}

	onDateChange(day) {
		const available_day = moment(day);

		const data = {
			...this.state.data,
			available_day: available_day.format('DD/MM/YYYY'),
			available_day_u: available_day.format('YYYY-MM-DD')
		};
		this.props.onUpdate(data);

		this.setState({
			isOpen: false
		})

		this.onChangeCheckErrors("available_day");
	}

	openPopup() {
		this.setState({
			isOpen: true,
			month: this.state.data.available_day_u === "" ? this.state.month : moment(this.state.data.available_day_u).toDate()
		});
	}

	onPopupClose(){
		this.setState({
			isOpen: false
		});
	}

	onSubmit = e => {
		e.preventDefault();
		const errors = this.validate(this.state.data);
		
		this.setState({ errors });

		if(Object.keys(errors).length === 0) {
			this.props.onNextStep("application");
		}
	}

	validate(data) {
		const errors = {};

		if(this.props.data.jobId === 0 && !data.job) errors.job = true;
		if(!data.job_hours) errors.job_hours = true;
		if(!data.qualifications) errors.qualifications = true;
		if(!data.available_day) errors.available_day = true;

		return errors;
	}

	render() {
		const { data, errors, loading } = this.state;
		const available_day = data.available_day_u === "" ? moment().toDate() : moment(data.available_day_u).toDate();

		let salaryPer = translate("xxltable.step3.expected_salary_1");
		if(this.state.job_hours_id > 1) {
			salaryPer = translate("xxltable.step3.expected_salary_2");
		}

		return (
			<Form onSubmit={this.onSubmit.bind(this)} loading={loading}>

				<Form.Group widths="equal">
					{this.props.data.jobId === 0 && 
						(
							<div className="field">
								<label>{translate("xxltable.step3.job.label")}</label>
								<Dropdown
									error={!!errors.job}
									onChange={this.onChangeSUI.bind(this)}
									options={jobs}
									selection
									placeholder={translate("xxltable.step3.select_job")}
									name="job"
									value={data.job}
									/>
							</div>
			  			)
		  			}

		  			<div className="field">
						<label>{translate("xxltable.step3.job_hours.label")}</label>
						<Dropdown
							error={!!errors.job_hours}
							onChange={this.onChangeSUI.bind(this)}
							options={job_hours}
							selection
							placeholder={translate("xxltable.step3.select_job_hours")}
							name="job_hours"
							value={data.job_hours}
							/>
					</div>
				</Form.Group>

				<Form.Group widths="equal">
					<div className="field">
						<label>{translate("xxltable.step3.qualifications.label")}</label>
						<Dropdown
							error={!!errors.qualifications}
							onChange={this.onChangeSUI.bind(this)}
							options={qualifications}
							selection
							placeholder={translate("xxltable.step3.select_qualifications")}
							name="qualifications"
							value={data.qualifications}
							/>
					</div>

		  			<div className="field">
						<label>{translate("xxltable.step3.work_year_experience.label")}</label>
						<Dropdown
							onChange={this.onChangeSUI.bind(this)}
							options={work_year_experience_options}
							selection
							name="work_year_experience"
							value={data.work_year_experience}
							/>
					</div>
				</Form.Group>

				<Form.Group widths="equal">
					<div className="field">
						<label>{translate("xxltable.step3.eu_work_permit.label")}</label>
						<Dropdown
							onChange={this.onChangeSUI.bind(this)}
							options={eu_work_permit_options}
							selection
							name="eu_work_permit"
							value={data.eu_work_permit}
							/>
					</div>

					<div className="field">
		  				<label>{translate("xxltable.step3.expected_salary")}</label>
		  				<Input
						    label={{ basic: true, content: salaryPer }}
						    labelPosition='right'
						    placeholder={translate("xxltable.step3.expected_salary")}
						    name="expected_salary"
						    value={data.expected_salary}
						    onChange={this.onChange.bind(this)}
						/>
		  			</div>

					<Popup
						ref="available_dayPopup"
						trigger={
							<Form.Input
								label={translate("xxltable.step3.available_day")}
								placeholder={translate("xxltable.step3.available_day")}
								icon="calendar"
								iconPosition="left"
								name={'crypto_'+CryptoJS.AES.encrypt("available_day", this.form_field_key).toString()}
								value={data.available_day}
								onChange={this.onChange.bind(this)}
								error={!!errors.available_day}
								onClick={this.openPopup.bind(this)}
							/>
						}
						on='click'
						position='bottom left'
						open={this.state.isOpen}
						onClose={this.onPopupClose.bind(this)}
					>
						<DayPicker
							month={available_day}
							selectedDays={available_day}
							onDayClick={this.onDateChange.bind(this)}
						/>
					</Popup>
				</Form.Group>

				<Form.Group widths="equal">
					<div className="field">
						<label>{translate("xxltable.step3.languages_main.label")}</label>
						<Dropdown
						    multiple
						    selection
						    fluid
						    search
						    onChange={this.onChangeSUI.bind(this)}
						    options={isoLangs}
						    renderLabel={renderLabel}
						    name="languages_main"
						    value={data.languages_main}
						  />
					  </div>

					  <div className="field">
						<label>{translate("xxltable.step3.languages_rest.label")}</label>
						<Dropdown
						    multiple
						    selection
						    fluid
						    search
						    onChange={this.onChangeSUI.bind(this)}
						    options={isoLangs}
						    renderLabel={renderLabel}
						    name="languages_rest"
						    value={data.languages_rest}
						  />
					  </div>
				</Form.Group>

				<Form.Group widths="equal">
					<div className="field">
						<label>{translate("xxltable.step3.comment.label")}</label>
						<Form.TextArea
							placeholder={translate("xxltable.step3.comment.placeholder")}
							name="comment"
							value={data.comment}
							onChange={this.onChange.bind(this)}
							error={!!errors.comment}
						/>
					</div>
				</Form.Group>

				<div className="ui center aligned container">
					<Form.Button positive>{translate("xxltable.step3.btn_next")}</Form.Button>
				</div>
			</Form>
		);
	}
}

export default ApplicationForm;


// WEBPACK FOOTER //
// ./src/components/forms/ApplicationForm.js